export default __webpack_public_path__ + "static/media/balance-wellness-evaluated.3f1e56df.md";